import type {TranslateResult} from  "vue-i18n"

export default class SelectOption<T> implements ISelectOption<T>{
	public readonly value: T
	public readonly text: string
	public readonly icon?: string
	public readonly disabled: boolean

	constructor(value: T, text: string | TranslateResult, icon?: string, disabled = false) {
		this.value = value
		this.text = text.toString()
		this.icon = icon
		this.disabled = disabled
	}

	public toString(): string {
		return this.text
	}

	public static createSimple(value: string): SelectOption<string> {
		return new SelectOption<string>(value, value)
	}
}

export interface ISelectOption<T> {
	readonly value: T
	readonly text: string
	readonly icon?: string
	readonly disabled: boolean
}
